// Шапка и фон сетки лонча: месяцы и дни (недель нет — как в старом); выходные серым, сегодня красным. Ширина дня — grid.dayWidth.
import { addDays, dayLabel, isoWeekday, type ISODate } from '@core/dates';
import { HEADER_HEIGHT, HEADER_ROWS, MIN_MONTH_LABEL, periodSpans, type Grid } from '../roadmap/shared/geometry';

const MONTH_ROW = HEADER_ROWS.months; // строка дней добирает до HEADER_HEIGHT: угол сетки той же высоты

export function LaunchHeader({ grid }: { grid: Grid }) {
  const months = periodSpans(grid, 'month');
  const days: ISODate[] = [];
  for (let i = 0; i < grid.days; i++) days.push(addDays(grid.start, i));
  return (
    <div style={{ width: grid.width }}>
      <div className="relative bg-blue-50 border-b border-gray-300" style={{ height: MONTH_ROW }}>
        {months.map((m) => (
          <span key={m.key} className="absolute top-0 bottom-0 flex items-center justify-center font-semibold border-r border-gray-300 overflow-hidden whitespace-nowrap" style={{ left: m.left, width: m.width }} title={m.label}>{m.width >= MIN_MONTH_LABEL ? m.label : ''}</span>
        ))}
      </div>
      <div className="relative bg-gray-50 border-b border-gray-200" style={{ height: HEADER_HEIGHT - MONTH_ROW }}>
        {days.map((d, i) => (
          <span key={d} data-day={d} className={`absolute top-0 bottom-0 flex items-center justify-center text-xs border-r border-gray-200 ${isoWeekday(d) >= 6 ? 'bg-gray-100 text-gray-500' : ''}`} style={{ left: i * grid.dayWidth, width: grid.dayWidth }}>{dayLabel(d)}</span>
        ))}
      </div>
    </div>
  );
}

/** Фон строки: выходные, границы месяцев, сегодня. */
export function LaunchLines({ grid, todayX, weekends = true }: { grid: Grid; todayX: number | null; weekends?: boolean }) {
  const months = periodSpans(grid, 'month').slice(1);
  const weekendDays: number[] = [];
  for (let i = 0; i < grid.days; i++) if (isoWeekday(addDays(grid.start, i)) >= 6) weekendDays.push(i);
  return (
    <>
      {/* без линий дней и недель — как в старом Launch View: полосы выходных и границы месяцев читаются лучше сетки (Глеб, 2026-09-11) */}
      {weekends && weekendDays.map((i) => <span key={i} className="absolute top-0 bottom-0 bg-gray-100" style={{ left: i * grid.dayWidth, width: grid.dayWidth }} />)}
      {months.map((m) => <span key={m.key} className="absolute top-0 bottom-0 border-l-2 border-gray-400" style={{ left: m.left }} />)}
      {todayX !== null && <span className="absolute top-0 bottom-0 bg-red-500/15 z-[6] pointer-events-none" style={{ left: todayX, width: grid.dayWidth }} />}
    </>
  );
}

